<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="3" class="py-2">
                <span>Inventory</span>
              </b-col>
              <b-col cols="12" md="3" class="py-2">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  router-link
                  to="/Inventory/Add"
                  >Add New Item</b-button
                >
              </b-col>
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="products"
            :fields="fields"
            @row-clicked="rowClicked"
          >
            <template v-slot:cell(name)="data">
              <span v-if="data.item.name.length > 50">{{
                data.item.name.slice(0, 50) + "..."
              }}</span>
              <span v-else>{{ data.item.name }}</span>
            </template>
            <template v-slot:cell(description)="data">
              <span>{{ data.item.description.slice(0, 40) + "..." }}</span>
            </template>
            <template v-slot:cell(range)="data">
              <span v-if="data.item.range">{{ data.item.range.name }}</span>
              <span v-else>-</span>
            </template>
          </b-table>
          <nav>
            <pagination
              v-model="currentPage"
              :records="totalData"
              :per-page="perPage"
              @paginate="nextPage"
            />
          </nav>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      products: [],
      fields: [
        { key: "itemcode", label: "Item Code", sortable: false },
        { key: "name", label: "Name", sortable: false },
        { key: "inventory.selling_price", label: "MRP", sortable: false },
        {
          key: "inventory.price",
          label: "Selling Price",
          sortable: false,
        },
        // {
        //   key: "inventory.available_quantity",
        //   label: "Available Quantity",
        //   sortable: false,
        // },
        { key: "description", label: "Description", sortable: false },
        { key: "inventory.enabled", label: "Enabled", sortable: false },
      ],
      totalData: 0,
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
    };
  },
  mounted() {
    if (this.$route.query.page)
      this.currentPage = Number(this.$route.query.page);
    this.getData();
  },
  methods: {
    nextPage(ev) {
      this.currentPage = ev;
      this.$router.push({
        path: "/Inventory/" + this.$route.params.id,
        query: {
          page: this.currentPage,
        },
      });
    },

    getData() {
      this.appLoading = true;
      axios({
        url: "/inventory/shop/cat",
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: {
          shop: localStorage.getItem("shopid"),
          category: this.$route.params.id,
          page: this.currentPage,
          limit: this.perPage,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.data) {
            this.inventory = response.data.data;
            for (var i = 0; i < this.inventory.length; i++) {
              if (this.$route.params.id == this.inventory[i]._id) {
                this.products = this.inventory[i].items;
              }
            }
            this.totalData = response.data.totalRecords;
          }
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    rowClicked(item) {
      this.$router.push(
        "/Inventory/" + this.$route.params.id + "/" + item.inventory._id
      );
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
